<template>
  <main-drawer :title="isEdit ? $tc('tournament.edit_club_deduction') : $tc('tournament.add_club_deduction')" @close="$emit('close')">
    <main-select
      v-model="form.clubId"
      :label="$tc('general.club')"
      :options="clubOptions"
      :validator="$v.form.clubId" />

    <main-input
      v-model.number="form.deduction"
      :label="$tc('club.cost_reduction')"
      :validator="$v.form.deduction"
      append="%" />

    <template v-slot:footer>
      <div class="flex-buttons">
        <el-button @click="$emit('close')">{{ $tc('general.cancel') }}</el-button>
        <el-button type="primary" @click="save()">{{ isEdit ? $tc('general.edit') : $tc('general.save') }}</el-button>
      </div>
    </template>
  </main-drawer>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'
import { required, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  props: {
    tournament: {
      type: Object,
      required: true
    },

    clubDeduction: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      form: {
        clubId: null,
        deduction: null
      }
    }
  },

  computed: {
    isEdit () {
      return !!this.clubDeduction
    },

    allClubs () {
      const clubs = this.$store.getters['clubs/list'] || []
      return clubs.filter(club => !club.isBlocked && !club.isDeleted)
    },

    existingClubIds () {
      return this.tournament.clubDeductions?.map(deduction => parseInt(deduction.clubId)) || []
    },

    clubOptions () {
      return this.allClubs
        .filter(club => !this.existingClubIds.includes(club.id) || (this.isEdit && this.clubDeduction.clubId === club.id))
        .map(club => ({
          id: club.id,
          text: club.name
        }))
    },

    user () {
      return this.$store.state.auth.user
    }
  },

  created () {
    if (this.clubDeduction) {
      this.form = {
        clubId: this.clubDeduction.clubId,
        deduction: this.clubDeduction.deduction
      }
    }

    this.$store.dispatch('clubs/load')
  },

  methods: {
    async save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return

      const payload = {
        clubId: this.form.clubId,
        deduction: this.form.deduction,
        tournamentId: this.tournament.id
      }

      this.loading = true
      try {
        let result
        if (this.isEdit) {
          result = await this.$store.dispatch('clubDeductions/update', {
            id: this.clubDeduction.id,
            payload
          })
        } else {
          result = await this.$store.dispatch('clubDeductions/create', payload)
        }
        this.$message.success(this.isEdit ? this.$tc('messages.success_updated_club_deduction') : this.$tc('messages.success_created_club_deduction'))
        this.$emit(this.isEdit ? 'edit' : 'add', result)
      } catch (error) {
        errorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  validations () {
    return {
      form: {
        clubId: { required },
        deduction: {
          required,
          minValue: minValue(0),
          maxValue: maxValue(100)
        }
      }
    }
  }
}
</script>
